import React from "react";

import Question from "../../components/question/Question";
import { IQuestion } from "../../app/types";
import { Loader, Container, Button } from "semantic-ui-react";
import { getNextWorstQuestion } from "../../app/api";

const TrainingPage = () => {
  const [question, setQuestion] = React.useState<IQuestion>();
  const [isAnswered, setIsAnswered] = React.useState(false);

  React.useEffect(() => {
    getNextWorstQuestion().then((question) => setQuestion(question));
  }, []);

  const onNextClick = () => {
    setQuestion(undefined);
    setIsAnswered(false);
    getNextWorstQuestion().then((question) => setQuestion(question));
  };

  if (!question) {
    return (
      <div>
        <Loader></Loader>
      </div>
    );
  }

  return (
    <Container style={{ paddingBottom: 50 }}>
      <Question
        question={question}
        onAnswer={() => setIsAnswered(true)}
      ></Question>
      <Button
        fluid
        color="green"
        size="massive"
        disabled={!isAnswered}
        onClick={onNextClick}
      >
        Следующий вопрос
      </Button>
    </Container>
  );
};

export default TrainingPage;
